import { navigate } from "gatsby"
import { Fragment } from "react"

import { Button } from "@trueskin-web/components"
import { storageService } from "@trueskin-web/services"
import { Routes } from "@trueskin-web/translations"

import { PhotoSlots, PhotosProvider, usePhotos } from "../../document-upload"

const uploadSuccessHandler = () => {
  storageService.removeItem({ id: storageService.getStorageKeys().BVDD_PRAXIS })
  navigate(Routes.App.Start.Photos.url, {
    replace: true,
  })
}

const ImageUploadContainer = () => {
  const { hasRequiredPhotos, isUploadImagesLoading, uploadImages } = usePhotos()

  const onSubmit = () => {
    try {
      uploadImages({
        onSuccess: () => {
          uploadSuccessHandler()
        },
      })
    } catch (error) {}
  }

  return (
    <Fragment>
      <PhotoSlots
        sx={{
          mt: 7,
        }}
      />

      <Button
        isFullWidth
        isLoading={isUploadImagesLoading}
        isDisabled={!hasRequiredPhotos}
        onClick={onSubmit}
        sx={{ mt: 7 }}
        rounded
      >
        Dokument einreichen
      </Button>
    </Fragment>
  )
}

const UploadPhotos = () => {
  return (
    <PhotosProvider>
      <ImageUploadContainer />
    </PhotosProvider>
  )
}

export default UploadPhotos
